/**
 * 拼接完整图片URL
 * @param {string} path 后端返回的相对路径
 * @returns {string} 完整URL
 */
export function getImageUrl(path) {
  if (!path) return '';

  // 已经是完整URL则直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // 从环境变量获取基础URL，默认值用于开发环境
  let baseUrl = process.env.VUE_APP_API_URL || 'https://ywtb.cqtc.edu.cn';
  if(process.env.VUE_APP_API_URL.length < 2){
    baseUrl = 'https://ywtb.cqtc.edu.cn';
  }

  // 处理路径开头的斜杠
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
}
